// ==========================================
// GuestBanner.js - Persistent banner for anonymous/guest users
// ==========================================
import React, { useState } from 'react';
import { X } from 'lucide-react';

const GuestBanner = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-300 rounded-xl p-3 mb-4 flex items-center gap-3 shadow-sm">
      <span className="text-xl flex-shrink-0">👤</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-amber-900">Browsing as Guest</p>
        <p className="text-xs text-amber-700">
          <a href="/login" className="underline font-semibold hover:text-amber-900">Sign in or create an account</a>
          {' '}to post, message, and connect with other pet lovers.
        </p>
      </div>
      <a
        href="/login"
        className="flex-shrink-0 px-3 py-1.5 bg-amber-500 text-white rounded-lg text-xs font-semibold hover:bg-amber-600 transition"
      >
        Sign In
      </a>
      <button
        onClick={() => setDismissed(true)}
        className="flex-shrink-0 text-amber-400 hover:text-amber-600 transition p-1"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default GuestBanner;